import axios from "axios";
import { getResourceManagerUrls } from "./endpoints/resourceManager";
import { downloadBlob } from "../../util/filterHelpers";

async function post(url, data = null) {
  const res = await axios.post(url, data);
  if (res.status === 200) return res.data;
  throw new Error("Error in response - " + res);
}

export async function fetchResourceManagerQueue(filterDto, domain) {
  const urls = getResourceManagerUrls(domain);
  return await post(urls.Queue, filterDto);
}

export async function fetchResourceManagerQueueFilters(payload, domain) {
  const urls = getResourceManagerUrls(domain);
  return await post(urls.QueueFilters, payload);
}

export async function fetchOrderDetail(
  requestId,
  domain,
  engagementManagerMailId,
) {
  const urls = getResourceManagerUrls(domain);
  const payload = { requestId };
  if (engagementManagerMailId)
    payload.engagementManagerMailId = engagementManagerMailId;
  return await post(urls.OrderDetail, payload);
}

export async function exportResourceManagerQueue(filterDto, domain) {
  const urls = getResourceManagerUrls(domain);
  const res = await axios.post(urls.ExportExcel, filterDto, {
    responseType: "blob",
  });
  const isAOA = String(domain).toUpperCase() === "AOA";
  const disposition = res.headers["content-disposition"] || "";
  const match = disposition.match(/filename[^;=\n]*=["']?([^"';\n]+)/);
  const defaultName = isAOA ? "PMOQueue.xlsx" : "ResourceManagerQueue.xlsx";
  const filename = isAOA ? defaultName : match?.[1] || defaultName;
  downloadBlob(res.data, filename);
}

export async function assignEngagementManager({
  requestIds,
  engagementManagerEmail,
  firstName,
  lastName,
  actingUserEmail,
  domain,
}) {
  const urls = getResourceManagerUrls(domain);
  return await post(urls.AssignEngagementManager, {
    requestIds,
    engagementManagerEmail,
    firstName,
    lastName,
    actingUserEmail,
  });
}
